import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import ManagerNavBar from '../../Components/NavigationBar/ManagerNavBar';
import WarehouseCategory from '../../Components/Manager/Warehouse/Warehouse';

const tabs = [
    { value: 'produkt', label: 'Produkty' },
    { value: 'element', label: 'Elementy' },
    { value: 'surowiec', label: 'Surowce' },
];

function ManagerWarehouse() {
    const [activeTab, setActiveTab] = useState('produkt');

    return (
        <ManagerNavBar>
            <Box sx={{ px: 6, py: 2 }}>
                <Typography sx={{ fontSize: '30px', fontWeight: 700, color: 'primary.main', mb: 3 }}>
                    Magazyn
                </Typography>

                <Tabs
                    value={activeTab}
                    onChange={(_, value) => setActiveTab(value)}
                    sx={{ mb: 3, minHeight: 'unset', '& .MuiTabs-indicator': { display: 'none' } }}
                >
                    {tabs.map((tab) => (
                        <Tab
                            key={tab.value}
                            label={tab.label}
                            value={tab.value}
                            disableRipple
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: '10px',
                                minHeight: 'unset',
                                px: 2.5,
                                py: 1,
                                mr: 1,
                                color: 'text.secondary',
                                '&.Mui-selected': { bgcolor: 'primary.main', color: '#fff' },
                            }}
                        />
                    ))}
                </Tabs>

                {/* Ten sam komponent renderuje wszystkie trzy kategorie — różni je tylko productType */}
                <WarehouseCategory productType={activeTab} />
            </Box>
        </ManagerNavBar>
    );
}

export default ManagerWarehouse;